import { userConstants } from '../userConstants';
import i18n from 'src/i18n';

export let columns = {
  customerUsersColumns: [
    {
      key: 'name', title: i18n.t('colName'), fieldName: 'name', widthInPercent: 'name',
      maxWidth: 35,
      isSortRequired: true,
      dataType: 'custom',
      sortedItem: { sortField: 'name', sortByAsc: true },
    },
    {
      key: 'department', title: i18n.t('colDept'), fieldName: 'department', widthInPercent: 'department',
      maxWidth: 15,
      dataType: 'string',
    },
    {
      key: 'role', title: i18n.t('colRole'), fieldName: 'role', widthInPercent: 'role',
      maxWidth: 12,
      dataType: 'custom',
    },
    {
      key: 'Phone', title: i18n.t('colPhone'), fieldName: 'phoneNumber', widthInPercent: 'facility',
      maxWidth: 20,
      dataType: 'string',
      className: 'phone-cell'
    },
  
  ],
  accountUsersColumns: [
    {
      key: 'name', title: i18n.t('colName'), fieldName: 'name', widthInPercent: 'name',
      maxWidth: 35,
      isSortRequired: true,
      dataType: 'custom',
      sortedItem: { sortField: 'name', sortByAsc: true },
    },
    {
      key: 'department', title: i18n.t('colDept'), fieldName: 'department', widthInPercent: 'department',
      maxWidth: 15,
      dataType: 'string',
    },
    {
      key: 'facility', title: i18n.t('colFacility'), fieldName: 'primaryFacilityName', widthInPercent: 'facility',
      maxWidth: 20,
      dataType: 'custom',
      className: 'facility-cell'
    },
    {
      key: 'role', title: i18n.t('colRole'), fieldName: 'role', widthInPercent: 'role',
      maxWidth: 15,
      dataType: 'custom',
    },
    {
      key: 'actions', title: '', fieldName: 'actions', widthInPercent: 'actions',
      maxWidth: 15,
      dataType: 'button',
      buttonText: userConstants.accountUsers.tableBtnText,
      iconName: userConstants.accountUsers.tableBtnIcon,
    }
  ],
  customerUsersAccordionColumns: [{
    key: 'department', title: i18n.t('colDept'), fieldName: 'department', widthInPercent: 20,
    maxWidth: 20,
    dataType: 'string',
  },
  {
    key: 'role', title: i18n.t('colRole'), fieldName: 'role', widthInPercent: 20,
    maxWidth: 20,
    dataType: 'custom',
  },
  {
    key: 'Phone', title: i18n.t('colPhone'), fieldName: 'phoneNumber', widthInPercent: 15,
    maxWidth: 15,
    dataType: 'string',
    className: 'phone-cell'
  },
  {
    key: 'actions', title: '', fieldName: 'actions', widthInPercent: 15,
    maxWidth: 15,
    dataType: 'button',
    buttonText: userConstants.customerUsers.tableBtnText,
    iconName: userConstants.customerUsers.tableBtnIcon,
  },
  {
    key: 'disable', title: '', fieldName: 'disableActions', widthInPercent: 15,
    maxWidth: 15,
    dataType: 'custom',
  }
  ],
  accountUsersAccordionColumns: [
    {
      key: 'department', title: i18n.t('colDept'), fieldName: 'department', widthInPercent: 20,
      maxWidth: 20,
      dataType: 'string',
    },
    {
      key: 'facility', title: i18n.t('colFacility'), fieldName: 'primaryFacilityName', widthInPercent: 30,
      maxWidth: 30,
      dataType: 'custom',
      className: 'facility-cell'
    },
    {
      key: 'role', title: i18n.t('colRole'), fieldName: 'role', widthInPercent: 15,
      maxWidth: 15,
      dataType: 'custom',
    },
    {
      key: 'actions', title: '', fieldName: 'actions', widthInPercent: 15,
      maxWidth: 15,
      dataType: 'button',
      buttonText: userConstants.accountUsers.tableBtnText,
      iconName: userConstants.accountUsers.tableBtnIcon,
    },
    {
      key: 'disable', title: '', fieldName: 'disableActions', widthInPercent: 15,
      maxWidth: 15,
      dataType: 'custom',
    }
  ]
};

export const rowData = [
  {
    "name": "Matilda Wilkerson",
    "department": "Intensive Care",
    "entRoles": ["PARTICIPANT", "TRAINER"],
    "phoneNumber": "123-456-7890",
    "role": "Doctor",
    "active": true,
    "facility": { facilityName: "Children H'pital", facilityAddress: "AnyStreet Dr. Milwaukee, WI, 481294-2200 USA" },
    "email": "name@email.com"
  },
  {
    "name": "John Doe",
    "department": "Intensive Care",
    "entRoles": ["PARTICIPANT", "ADMIN"],
    "phoneNumber": "123-456-7890",
    "role": "Technologist",
    "active": true,
    "facility": { facilityName: "Children H'pital", facilityAddress: "AnyStreet Dr. Milwaukee, WI, 481294-2200 USA" },
    "email": "name@email.com"
  },
  {
    "name": "Elnora Garza",
    "department": "",
    "entRoles": ["ADMIN"],
    "phoneNumber": "123-456-7890",
    "role": "Director",
    "active": false,
    "facility": { facilityName: "Children H'pital", facilityAddress: "AnyStreet Dr. Milwaukee, WI, 481294-2200 USA" },
    "email": "name@email.com"
  },
  {
    "name": "Max Chavez",
    "department": "-",
    "entRoles": ["PARTICIPANT", "ADMIN"],
    "phoneNumber": "123-456-7890",
    "role": "-",
    "active": true,
    "facility": { facilityName: "Children H'pital", facilityAddress: "AnyStreet Dr. Milwaukee, WI, 481294-2200 USA" },
    "email": "name@email.com"
  },
  {
    "name": "Jesse Lane",
    "department": "Intensive Care",
    "entRoles": ["PARTICIPANT", "ADMIN"],
    "phoneNumber": "123-456-7890",
    "role": "Department manager",
    "active": true,
    "facility": { facilityName: "Children H'pital", facilityAddress: "AnyStreet Dr. Milwaukee, WI, 481294-2200 USA" },
    "email": "name@email.com"
  },
  {
    "name": "Luke Cohen",
    "department": "Cardiology",
    "entRoles": ["PARTICIPANT", "TRAINER"],
    "phoneNumber": "123-456-7890",
    "role": "Technologist",
    "active": true,
    "facility": { facilityName: "Children H'pital", facilityAddress: "AnyStreet Dr. Milwaukee, WI, 481294-2200 USA" },
    "email": "name@email.com"
  }
]

export let ENT_ROLES_MAPPING = {
  "PARTICIPANT": i18n.t('user'),
  "ADMIN": i18n.t('admin'),
  "TRAINER": i18n.t('expert'),
}

i18n.on('languageChanged', function () {
  updateTranslations();
});

function updateTranslations() {
  ENT_ROLES_MAPPING = {
    "PARTICIPANT": i18n.t('user'),
    "ADMIN": i18n.t('admin'),
    "TRAINER": i18n.t('expert'),
  };
  columns = {
    customerUsersColumns: [
      {
        key: 'name', title: i18n.t('colName'), fieldName: 'name', widthInPercent: 'name',
        maxWidth: 35,
        isSortRequired: true,
        dataType: 'custom',
        sortedItem: { sortField: 'name', sortByAsc: true },
      },
      {
        key: 'department', title: i18n.t('colDept'), fieldName: 'department', widthInPercent: 'department',
        maxWidth: 15,
        dataType: 'string',
      },
      {
        key: 'role', title: i18n.t('colRole'), fieldName: 'role', widthInPercent: 'role',
        maxWidth: 12,
        dataType: 'custom',
      },
      {
        key: 'Phone', title: i18n.t('colPhone'), fieldName: 'phoneNumber', widthInPercent: 'facility',
        maxWidth: 20,
        dataType: 'string',
        className: 'phone-cell'
      },
    
    ],
    accountUsersColumns: [
      {
        key: 'name', title: i18n.t('colName'), fieldName: 'name', widthInPercent: 'name',
        maxWidth: 35,
        isSortRequired: true,
        dataType: 'custom',
        sortedItem: { sortField: 'name', sortByAsc: true },
      },
      {
        key: 'department', title: i18n.t('colDept'), fieldName: 'department', widthInPercent: 'department',
        maxWidth: 15,
        dataType: 'string',
      },
      {
        key: 'facility', title: i18n.t('colFacility'), fieldName: 'primaryFacilityName', widthInPercent: 'facility',
        maxWidth: 20,
        dataType: 'custom',
        className: 'facility-cell'
      },
      {
        key: 'role', title: i18n.t('colRole'), fieldName: 'role', widthInPercent: 'role',
        maxWidth: 15,
        dataType: 'custom',
      },
      {
        key: 'actions', title: '', fieldName: 'actions', widthInPercent: 'actions',
        maxWidth: 15,
        dataType: 'button',
        buttonText: userConstants.accountUsers.tableBtnText,
        iconName: userConstants.accountUsers.tableBtnIcon,
      }
    ],
    customerUsersAccordionColumns: [{
      key: 'department', title: i18n.t('colDept'), fieldName: 'department', widthInPercent: 20,
      maxWidth: 20,
      dataType: 'string',
    },
    {
      key: 'role', title: i18n.t('colRole'), fieldName: 'role', widthInPercent: 20,
      maxWidth: 20,
      dataType: 'custom',
    },
    {
      key: 'Phone', title: i18n.t('colPhone'), fieldName: 'phoneNumber', widthInPercent: 15,
      maxWidth: 15,
      dataType: 'string',
      className: 'phone-cell'
    },
    {
      key: 'actions', title: '', fieldName: 'actions', widthInPercent: 15,
      maxWidth: 15,
      dataType: 'button',
      buttonText: userConstants.customerUsers.tableBtnText,
      iconName: userConstants.customerUsers.tableBtnIcon,
    },
    {
      key: 'disable', title: '', fieldName: 'disableActions', widthInPercent: 15,
      maxWidth: 15,
      dataType: 'custom',
    }
    ],
    accountUsersAccordionColumns: [
      {
        key: 'department', title: i18n.t('colDept'), fieldName: 'department', widthInPercent: 20,
        maxWidth: 20,
        dataType: 'string',
      },
      {
        key: 'facility', title: i18n.t('colFacility'), fieldName: 'primaryFacilityName', widthInPercent: 30,
        maxWidth: 30,
        dataType: 'custom',
        className: 'facility-cell'
      },
      {
        key: 'role', title: i18n.t('colRole'), fieldName: 'role', widthInPercent: 15,
        maxWidth: 15,
        dataType: 'custom',
      },
      {
        key: 'actions', title: '', fieldName: 'actions', widthInPercent: 15,
        maxWidth: 15,
        dataType: 'button',
        buttonText: userConstants.accountUsers.tableBtnText,
        iconName: userConstants.accountUsers.tableBtnIcon,
      },
      {
        key: 'disable', title: '', fieldName: 'disableActions', widthInPercent: 15,
        maxWidth: 15,
        dataType: 'custom',
      }
    ]
  };
}